import {routes} from './formacao.routes';
import FormacaoListController from "./directory/directory.controller";
import FormacaoService from "./formacao.service";
import FormacaoDetailsController from "./details/details.controller";

export default angular.module('app.formacao', [])
  .config(routes)
  .controller('FormacaoListController', FormacaoListController)
  .service('FormacaoService', FormacaoService)
  .controller('FormacaoDetailsController', FormacaoDetailsController)
  .name;
